var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSection4Line(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 470,
    height: 9,
    viewBox: "0 0 470 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 455,
    height: 3,
    transform: "matrix(-1 0 0 1 462 3)",
    fill: "#00B5EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 9C6.98528 9 9 6.98528 9 4.5C9 2.01472 6.98528 0 4.5 0C2.01472 0 0 2.01472 0 4.5C0 6.98528 2.01472 9 4.5 9ZM4.5 6C5.32843 6 6 5.32843 6 4.5C6 3.67157 5.32843 3 4.5 3C3.67157 3 3 3.67157 3 4.5C3 5.32843 3.67157 6 4.5 6Z",
    fill: "#00B5EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M465.5 9C467.985 9 470 6.98528 470 4.5C470 2.01472 467.985 0 465.5 0C463.015 0 461 2.01472 461 4.5C461 6.98528 463.015 9 465.5 9ZM465.5 6C466.328 6 467 5.32843 467 4.5C467 3.67157 466.328 3 465.5 3C464.672 3 464 3.67157 464 4.5C464 5.32843 464.672 6 465.5 6Z",
    fill: "#00B5EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSection4Line);
export default __webpack_public_path__ + "static/media/section4_line.ed1b97324aec434b2a93fda488a18232.svg";
export { ForwardRef as ReactComponent };